import React from 'react';
import ReactDOM from 'react-dom';

import IntegratorsDrawer from 'src/common/components/IntegratorsDrawer';
import IntegratorTag from 'src/common/components/IntegratorTag';

export default class IntegratorsHandler {
  static renderTagsAndDrawer() {
    ReactDOM.render(<IntegratorsDrawer />, document.getElementById('integrators-drawer'));

    const tags = document.querySelectorAll('.integrator-tag');
    Array.from(tags).forEach((tag) => {
      const tagLabel = tag.dataset.label;
      ReactDOM.render(<IntegratorTag label={tagLabel} />, tag);
    });
  }
}
